import {
  changeProjectStatus,
  fetchProject,
  modifyProject,
} from "api/counsilors";
import ArticleDetails from "components/ArticleDetails";
import ApproveArticle from "components/Modal/ApproveArticle";
import CounsilorDetails from "components/Modal/CounsilorDetails";
import DeleteArticle from "components/Modal/DeleteArticle";
import RejectArticle from "components/Modal/RejectArticle";
import {
  setCurrentPageNo,
  setLoading,
  setSelectedUser,
  setTotalPageNo,
} from "pages/ArticlesApprovalManagement/articlesSlice";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import TabComp from "themes/elements/Tab";
import ArticleApprovelTable from "themes/elements/Table/ArticleApprovelTable";
function ArticleApprovalManagement() {
  const dispatch = useDispatch();
  const [filterTitle, setFilterTitle] = useState(null);
  const [filterAuthor, setFilterAuthor] = useState(null);
  const isFirstLoad = useRef(true);

  const [filterReason, setFilterReason] = useState(null);
  const [filterStatus, setFilterStatus] = useState({ value: 4, name: "All" });
  const [filterWard, setFilterWard] = useState(null);
  const [filterCouncillor, setFilterCouncillor] = useState(null);
  const [filterReqCouncillor, setFilterReqCouncillor] = useState(null);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [details, setDetails] = useState(false);
  const [filterTerm, setFilterTerm] = useState();
  const [tabActive, setTabActive] = useState("1");
  const [isApprove, setIsApprove] = useState(false);
  const [isDetailsModal, setIsDetailsModal] = useState(false);

  const [isChangeLoading, setIsChangeLoading] = useState(false);
  const [articlesData, setArticlessData] = useState([]);
  const [filterSubmit, setFilterSubmit] = useState(null);
  const [filterPublish, setFilterPublish] = useState(null);
  const [isReject, setIsReject] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  const columnData = [
    {
      title: "Title",
      key: "title",
      filter: "searchTitle",
      width: 270,
    },
    {
      title: "Author",
      key: "author",
      filter: "searchAuther",
      width: 250,
    },
    {
      title: "WARD",
      key: "ward_code",
      filter: "searchNumber",
      width: 100,
    },
    {
      title: "COUNCILLOR",
      key: "created_user_name",
      filter: "searchCouncillor",
      width: 270,
    },
  ];

  // Conditionally add 'Submitted Date' column when tabActive is not "2"
  if (tabActive !== "2") {
    columnData.splice(2, 0, {
      title: "Submitted Date",
      key: "submitted_date",
      filter: "datePickerSubmit",
      width: 160,
    });
  }

  if (tabActive === "2") {
    // Insert 'Published Date' column right after 'Author'
    const authorIndex = columnData.findIndex(
      (column) => column.key === "author"
    );
    columnData.splice(authorIndex + 1, 0, {
      title: "Published Date",
      key: "published_date",
      filter: "published_date",
      width: 160,
    });

    // Add 'Status' column at the end
    columnData.push({
      title: "Status",
      key: "status",
      filter: "selectStatus",
      dropDown: [
        { value: 4, name: "All" },
        { value: 2, name: "Published" },
        { value: 3, name: "Rejected" },
      ],
      chip: true,
      width: 175,
    });
  }

  const { isLoading, selectedUser, currentPageNo, totalPageNo } = useSelector(
    (state) => state.projects
  );

  const loadProjects = async () => {
    dispatch(setLoading(true));

    try {
      const params = {
        page: currentPageNo,
        perPage: 10,
        status: tabActive === "1" ? 1 : filterStatus.value,
        councilorName: filterCouncillor && filterCouncillor,
        wardCode: filterWard && Number(filterWard),
        publishedDate: filterPublish,
        title: filterTitle ? filterTitle : "",
        submittedDate: filterSubmit,
        createdUserName: filterAuthor ? filterAuthor : "",
        // isApproval: 1,
      };
      const articles = await fetchProject(params);
      if (articles?.meta) {
        setArticlessData(articles?.projects);
        if (currentPageNo === 1) {
          dispatch(setTotalPageNo(articles.meta.last_page * 10)); // Changed to totalPages, if your API returns total pages directly, use that instead of last_page * 10
        }
        dispatch(setCurrentPageNo(articles.meta.current_page)); // Use currentPage directly if it's provided
      }

      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    dispatch(setCurrentPageNo(1)); // Set the page number to 1
  }, [dispatch]);

  useEffect(() => {
    if (currentPageNo === 1 && isFirstLoad.current) {
      loadProjects(); // Trigger the initial data load after currentPageNo is set
      isFirstLoad.current = false; // Set first load flag to false
    }
  }, [currentPageNo]);

  useEffect(() => {
    if (!isFirstLoad.current) {
      loadProjects();
    }
  }, [
    currentPageNo,
    filterPublish,
    filterSubmit,
    tabActive,
    filterTerm,
    filterReason,
    filterWard,
    filterCouncillor,
    filterTitle,
    filterStatus,
    filterAuthor,
    filterReqCouncillor,
  ]);

  const tabsData = [
    {
      key: "1",
      label: "Pending",
      children: (
        <>
          {tabActive === "1" && (
            <ArticleApprovelTable
              filterPublish={filterPublish}
              filterSubmit={filterSubmit}
              setFilterSubmit={setFilterSubmit}
              setFilterPublish={setFilterPublish}
              isLoading={isLoading}
              setIsApprove={setIsApprove}
              column={columnData}
              data={articlesData}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              setDetails={setDetails}
              setFilterAuthor={setFilterAuthor}
              filterAuthor={filterAuthor}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
              }}
              approve
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
              setFilterReason={setFilterReason}
              filterReason={filterReason}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setIsReject={setIsReject}
              setIsDetails={setIsDetailsModal}
              setFilterReqCouncillor={setFilterReqCouncillor}
              filterReqCouncillor={filterReqCouncillor}
            />
          )}
        </>
      ),
    },
    {
      key: "2",
      label: "History",
      children: (
        <>
          {tabActive === "2" && (
            <ArticleApprovelTable
              setFilterAuthor={setFilterAuthor}
              filterAuthor={filterAuthor}
              filterPublish={filterPublish}
              filterSubmit={filterSubmit}
              setFilterSubmit={setFilterSubmit}
              setFilterPublish={setFilterPublish}
              isLoading={isLoading}
              column={columnData}
              setDetails={setDetails}
              setIsApprove={setIsApprove}
              data={articlesData}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterWard={filterWard}
              setFilterWard={setFilterWard}
              filterCouncillor={filterCouncillor}
              setFilterCouncillor={setFilterCouncillor}
              onDeleteAction={(data) => {
                setIsDelete(true);
                dispatch(setSelectedUser(data));
              }}
              dataClick={(data) => {
                dispatch(setSelectedUser(data));
              }}
              setFilterReason={setFilterReason}
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              filterTerm={filterTerm}
              setFilterTerm={setFilterTerm}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setIsReject={setIsReject}
              setIsDetails={setIsDetailsModal}
              setFilterReqCouncillor={setFilterReqCouncillor}
              filterReqCouncillor={filterReqCouncillor}
            />
          )}
        </>
      ),
    },
  ];

  function handleTabChange(key) {
    setFilterStatus({ value: 4, name: "All" });
    setFilterAuthor();
    setArticlessData([]);
    dispatch(setCurrentPageNo(1));
    setTabActive(key);
    setFilterTitle("");
    setFilterWard("");
    setFilterTerm();
    setFilterSubmit();
    setFilterCouncillor("");
    setFilterReason();
    setFilterReqCouncillor();
  }

  const handleFormSave = async (approval, reason) => {
    setIsChangeLoading(true);
    try {
      const res = await changeProjectStatus(
        approval
          ? {
              status: 2,
              councilorProjectId: selectedUser?.councilor_project_id,
              reason: "Article approved",
            }
          : {
              councilorProjectId: selectedUser?.councilor_project_id,
              status: 3,
              reason: reason,
            }
      );

      if (res) {
        toast.success(res?.message);
        setIsApprove(false);
        setIsReject(false);
        loadProjects();
        loadProjectsbyId();
      }
    } catch (error) {
    } finally {
      setIsChangeLoading(false);
    }
  };

  const deleteArticleData = async () => {
    const payload = {
      councilorId: selectedUser.councilor_id,
      wardCode: selectedUser.ward_code,
      title: selectedUser.ward_code,
      description: "",
      content: selectedUser.project_content,
      objectCount: 0,
      status: 0,
      action: "delete",
      councilorProjectId: selectedUser.councilor_project_id,
    };

    setIsDeleteLoading(true); // Make sure you define `setLoading` using `useState` in your component

    try {
      // Call the modifyProject API with the payload
      const response = await modifyProject(payload);
      // If successful, show a success message
      if (response) {
        toast.success(response.message);
        setIsDelete(false);
        dispatch(setCurrentPageNo(1));

        if (currentPageNo === 1) {
          loadProjects();
        }
      }
    } catch (error) {
      // If there's an error, show an error message
    } finally {
      setDetails(false);
      setIsDelete(false);
      setIsDelete(false);

      // Hide the loader after API call completion
      setIsDeleteLoading(false);
    }
  };

  const loadProjectsbyId = async () => {
    try {
      const params = {
        page: 1,
        perPage: 10,
        status: 4,
        projectId: selectedUser?.councilor_project_id,
      };

      const articles = await fetchProject(params);
      dispatch(setSelectedUser(articles?.projects[0]));

      if (articles?.meta) {
        // dispatch(setSelectedUser(articles?.projects[0]));
      }
    } catch (error) {}
  };

  useEffect(() => {
    loadProjectsbyId();
  }, []);

  return (
    <div className="page-wrapper flex flex-column gap-4">
      <>
        {details ? (
          <ArticleDetails
            setIsDelete={setIsDelete}
            setIsReject={setIsReject}
            isDelete={isDelete}
            setIsApprove={setIsApprove}
            Approval={tabActive === "1"}
            isDeleteLoading={isDeleteLoading}
            deleteArticleData={deleteArticleData}
            onEdit={(data) => {
              dispatch(setSelectedUser(data));
            }}
            setOpen={setDetails}
            fetchNews={loadProjects}
            selectedArticle={selectedUser}
            tabActive={tabActive}
          />
        ) : (
          <>
            <h2 className="page-title">Approval management</h2>
            <TabComp
              isLoading={isLoading}
              tabActive={tabActive}
              handleTabChange={handleTabChange}
              // exportData={selectedData}
              // count={selectedData?.length}
              data={tabsData}
            />
          </>
        )}

        <RejectArticle
          setIsReject={setIsReject}
          isChangeLoading={isChangeLoading}
          isReject={isReject}
          selectedData={details}
          data={details}
          handleRejectCounsilor={(reason) => handleFormSave(false, reason)}
        />
        <ApproveArticle
          setIsApprove={setIsApprove}
          isApprove={isApprove}
          selectedData={details}
          isChangeLoading={isChangeLoading}
          data={details}
          handleApproveCounsilor={() => {
            handleFormSave(true);
          }}
        />

        <DeleteArticle
          isDeleteLoading={isDeleteLoading}
          setIsDelete={setIsDelete}
          isDelete={isDelete}
          selectedData={selectedUser}
          data={selectedUser}
          handleDeleteArticle={deleteArticleData}
        />
        <CounsilorDetails
          tabActive={tabActive}
          setDetails={setIsDetailsModal}
          isDetails={isDetailsModal}
          selectedData={selectedUser}
          data={selectedUser}
        />
      </>
    </div>
  );
}

export default ArticleApprovalManagement;
